
import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import HTMLReactParser from 'html-react-parser';
import { useMediaQuery } from 'react-responsive'
import { Link } from "@StarberryUtils";
import DachaMainImg from "./assets/img/dacha-main.png"
import DachaCameraImg from "./assets/img/dacha-camera-1.png"
import DachaPropertyImg from "./assets/img/dacha-property-2.png"
import DachaLanguagesImg from "./assets/img/dacha-languages-3.png"
import DachaLicenseImg from "./assets/img/dacha-license-4.png"
import DachaDatabaseImg from "./assets/img/dacha-database-5.png"
import DachaRecordImg from "./assets/img/dacha-record-6.png"
import DachaReputationImg from "./assets/img/dacha-reputation-7.png"
import "./About.scss"
// markup

const AnimationBlock = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)'
  })
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)'
  })

  return (
    <React.Fragment>  
      <section className={`sec-pdy-80 about-animation-wrapper`}>
      <Container>
        <Row className="align-items-center section-row">
        <Col xl={4}>   
        <div className="about-info-left about-info">
          <div animateIn='fadeInRight' animateOnce>
            <h4>{props.Title}</h4>
            {HTMLReactParser(props.Content.replace(/\n/g, '<br />'))}
          </div>
        </div>
        </Col>
        <Col xl={{ span: 7, offset: 1 }}>
        <div animateIn='fadeInRight' animateOnce className="about-info-right">
          <div className="property-management-animation-wrapper d-flex align-items-center justify-content-center">
            <table>
              <tr>
                <td></td>
                <td>
                  <ul className="list-inline">
                    <li className="list-inline-item property-sub-img property-img">
                      <img loading="lazy" src={DachaPropertyImg} alt="Property Management - Dacha" className="img-fluid" />
                      <div className="property-text">Property Management</div>
                    </li>
                    <li className="list-inline-item property-sub-img camera-img">
                      <img loading="lazy" src={DachaCameraImg} alt="Photo / Video - Dacha" className="img-fluid" />
                      <div className="property-text">Photo / Video</div> 
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <ul className="list-unstyled">
                    <li className="property-sub-img languages-img">
                      <img loading="lazy" src={DachaLanguagesImg} alt="Languages Image - Dacha" className="img-fluid" />
                      <div className="property-text">Languages</div>
                    </li>
                    <li className="property-sub-img license-img">
                      <img loading="lazy" src={DachaLicenseImg} alt="Licensed Specialists -Dacha" className="img-fluid" />
                      <div className="property-text">Licensed Specialists</div>
                    </li>
                    <li className="property-sub-img database-img">
                      <img loading="lazy" src={DachaDatabaseImg} alt="Database of Customers - Dacha" className="img-fluid" />
                      <div className="property-text">Database of Customers</div>
                    </li>
                  </ul>
                </td>
                <td className="property-main-img">
                  <img loading="lazy" src={DachaMainImg} alt="Our Story - Dacha" className="img-fluid" />
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <ul className="list-inline">
                    <li className="list-inline-item property-sub-img records-img">
                      <img loading="lazy" src={DachaRecordImg} alt="Track Record of Sales - Dacha" className="img-fluid" />
                      <div className="property-text">Track Record of Sales</div>
                    </li>
                    <li className="list-inline-item property-sub-img reputation-img">
                      <img loading="lazy" src={DachaReputationImg} alt="Reputation Since 2004 - Dacha" className="img-fluid" />
                      <div className="property-text">Reputation Since 2004</div>
                    </li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </div>
        </Col>
        </Row>

</Container>
      </section> 
    </React.Fragment >
  )
}

export default AnimationBlock